import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AccountInfo } from 'src/app/shared/models/accountInfo.model';
import { BuildingModel } from 'src/app/shared/models/building.model';
import { BuildingCategoryModel } from 'src/app/shared/models/complex-building-category.model';
import { SetTitle } from 'src/app/shared/ngxs/action/account.action';
import { GetBuilding } from 'src/app/shared/ngxs/action/building.action';
import { AccountState } from 'src/app/shared/ngxs/state/account.state';
import {
  ManageBuildingTypes,
  MapModeType,
} from './../../shared/models/enum.model';
import { GetAccountFromCache } from './../../shared/ngxs/action/account.action';
import { GetBuildingCategories } from './../../shared/ngxs/action/building.action';
import { BuildingState } from './../../shared/ngxs/state/building.state';

@Component({
  selector: 'app-building-preview',
  templateUrl: './building-preview.component.html',
  styleUrls: ['./building-preview.component.scss'],
})
export class BuildingPreviewComponent implements OnInit, OnDestroy {
  @Select(BuildingState.selected)
  selected$: Observable<BuildingModel>;

  subscription = new Subscription();
  model: BuildingModel;
  id: string;
  mapModes = MapModeType;
  singleMarker: MapModeType = MapModeType.SingleMarker;
  details = false;
  manageBuildingTypes = ManageBuildingTypes;

  currentAccount: AccountInfo = undefined;
  isAdministrator = false;

  categories = [];
  validCategories = [];

  @Select(BuildingState.categories)
  categories$: Observable<BuildingCategoryModel[]>;

  @Select(AccountState.account)
  account$: Observable<AccountInfo>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetAccountFromCache());
    this.store.dispatch(new GetBuildingCategories());

    if (!!this.route.snapshot.paramMap.get('id')) {
      this.id = this.route.snapshot.paramMap.get('id');
      this.subscribeEvents();
      this.store.dispatch(new GetBuilding(this.id));
    }

    this.getValidCategories();
  }

  getValidCategories() {
    let valid = [];

    const buildingCategories = this.categories.map((x) => x.name);

    if (this.isAdministrator) {
      return buildingCategories;
    }

    if (!this.isAdministrator && this.currentAccount) {
      valid = [];

      this.currentAccount?.categories?.forEach((categoryId) => {
        valid.push(this.categories.filter((x) => x.id == categoryId)[0]?.name);
      });
    }

    return valid;
  }

  subscribeEvents() {
    this.subscription.add(
      this.account$.subscribe((x) => {
        if (x) {
          this.currentAccount = x;
          this.isAdministrator = x.userType.toString() === 'Administrator';
        }
      })
    );

    this.subscription.add(
      this.categories$.subscribe((x) => {
        if (x) {
          this.categories = x;
          this.validCategories = this.getValidCategories();
        }
      })
    );

    this.subscription.add(
      this.selected$.subscribe((x) => {
        if (!!x) {
          this.model = x;
          this.store.dispatch(
            new SetTitle(`${this.model.street} ${this.model.streetNumber}`)
          );
        }
      })
    );
  }

  backToMap() {
    this.router.navigate(['/']);
  }

  transformDate(data: string) {
    return new Date(data).getFullYear();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
